export default __webpack_public_path__ + "static/media/Springboard_2.0_4c.20c8e309.png";